module.exports = __webpack_public_path__ + "img/schema_mobile.aa5f3ccc.png";